'use client';
import { CheckIcon } from '@ngg/icons';
import { cn } from '@ngg/storefront-utils';
import React, { ChangeEvent } from 'react';

type IProps = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  disabled?: boolean;
  name?: string;
  alt?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

function Checkbox(props: IProps) {
  const { onChange, checked, disabled, name, alt, ...rest } = props;
  return (
    <label className="hover:bg-grey md:mb-1.5 flex cursor-pointer items-center max-md:py-1">
      <div>
        <input
          className="hidden"
          name={name}
          checked={checked}
          value={name}
          onChange={(e) => {
            onChange(e);
          }}
          disabled={disabled}
          alt={alt}
          {...rest}
          type="checkbox"
        />
        <span
          className={cn(
            'h-em w-em flex-em peer-data-indeterminate:before:border-[0.5em] text-grey-150 before:transition-[border] peer-checked:before:border-[0.5em] relative block cursor-pointer rounded-none outline-none ring-offset-1 before:absolute before:left-0 before:top-0 before:h-full before:w-full before:border before:border-current before:border-gray-600 peer-focus-visible:ring peer-disabled:opacity-30',
            checked && 'bg-black before:border-black',
          )}>
          {checked && <CheckIcon color="white" />}
        </span>
      </div>
      <span className="ml-2 text-sm leading-none">{name}</span>
    </label>
  );
}

export default Checkbox;
